import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import * as FeatherIcon from 'react-feather';

const AdditionalWebsitesInputElem = ({setAdditionalWebisites}) => {
  const [websiteInput, setWebsiteInput] = useState("");
  const [errors, setErrors] = useState({});
  const [additionalContactWebsites, setAdditionalContactWebsites] = useState([]);

  useEffect(() => {
    setAdditionalWebisites(additionalContactWebsites)
  }, [additionalContactWebsites])

  // ✅ Validate website format
  const isValidWebsite = (url) => {
    const pattern = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(\/.*)?$/i;
    return pattern.test(url);
  };

  // ✅ Add valid websites to list
  const handleAddWebsites = () => {
    const newWebsites = websiteInput
      .split(",")
      .map((url) => url.trim())
      .filter((url) => url.length > 0);

    const invalidWebsite = newWebsites.find((url) => !isValidWebsite(url));
    if (invalidWebsite) {
      setErrors({
        contactWebsites:
          "Please enter valid website URLs (e.g., example.com or https://example.com).",
      });
      return;
    }

    if (newWebsites.length) {
      setAdditionalContactWebsites((prev) => [
        ...new Set([...prev, ...newWebsites]),
      ]);
      setWebsiteInput("");
      setErrors({});
    }
  };

  // ✅ Remove a website by index
  const removeWebsite = (idx) => {
    setAdditionalContactWebsites((prev) => prev.filter((_, i) => i !== idx));
  };

  return (
    <>
      <Form.Group className="mb-3">
        <label for="labelAccountName" class="form-label custom_label">
            Additional Websites 
            <span class="ml-1"><em>(comma-separated, if multiple)</em></span> 
        </label>

        <Form.Control
          type="text"
          className="form-control font13"
          placeholder="Add website links"
          value={websiteInput}
          onChange={(e) => {
            const value = e.target.value;
            setWebsiteInput(value);

            const websiteArray = value
              .split(",")
              .map((url) => url.trim())
              .filter((url) => url.length > 0);

            const invalidWebsite = websiteArray.find(
              (url) => !isValidWebsite(url)
            );
            if (invalidWebsite) {
              setErrors({
                contactWebsites:
                  "Please enter valid website URLs (with or without https://).",
              });
            } else {
              setErrors({});
            }
          }}
          onBlur={handleAddWebsites}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddWebsites();
            }
          }}
        />

        {errors.contactWebsites && (
          <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
            {errors.contactWebsites}
          </div>
        )}
      </Form.Group>

      <div className="d-flex flex-wrap gap-2 mb-2">
        {additionalContactWebsites.map((url, idx) => (
          <span key={idx} className="badge bg-primary website_keywords font11">
            <a
              href={url.startsWith("http") ? url : `https://${url}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white", textDecoration: "none" }}
            >
              {url}
            </a>
            <i onClick={() => removeWebsite(idx)}>
              <FeatherIcon.Trash2
                style={{
                  width: "16px",
                  height: "16px",
                  padding: "1px",
                  cursor: "pointer",
                }}
                className="img_trend ml-2"
              />
            </i>
          </span>
        ))}
      </div>
    </>
  );
};

export default AdditionalWebsitesInputElem;
